module.exports = __webpack_public_path__ + "static/media/cart.3f2d01d3.svg";